
import Papa from 'papaparse';
import * as XLSX from 'xlsx';

export async function rowsFromCsvOrXlsx(file) {
  const name = file.name.toLowerCase();
  if (name.endsWith('.csv')) {
    return new Promise((res, rej)=>{ Papa.parse(file, { header:true, skipEmptyLines:true, complete:(r)=>res(r.data), error: rej }); });
  }
  if (name.endsWith('.xlsx') || name.endsWith('.xls')) {
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data, { type:'array' });
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    return XLSX.utils.sheet_to_json(sheet, { defval: '' });
  }
  if (name.endsWith('.json')) {
    const text = await file.text(); try { const parsed = JSON.parse(text); return Array.isArray(parsed) ? parsed : [parsed]; } catch(e) { return []; }
  }
  return [];
}

export function exportRowsToCsv(rows, filename='export.csv') {
  if(!rows || rows.length===0) return;
  const cols = Object.keys(rows[0]);
  const csv = [cols.join(',')].concat(rows.map(r=>cols.map(c=>JSON.stringify(r[c] ?? '')).join(','))).join('\n');
  const blob = new Blob([csv], { type:'text/csv;charset=utf-8;' });
  const link = document.createElement('a'); const url = URL.createObjectURL(blob); link.href = url; link.download = filename; document.body.appendChild(link); link.click(); document.body.removeChild(link);
}
